module.exports = __webpack_public_path__ + "assets/img/ja-378f4538.png";